<template>
  <card title="Video Element" :element="element">
    <e-name :element="element"></e-name>
    <e-select-file
      :element="element"
      mode="videos"
      title="Select video"
    ></e-select-file>
    <e-text title="Caption" :element="element"></e-text>
    <e-is-background :element="element" type="video"></e-is-background>
    <!-- APPLIES TO BACKGROUND IMAGES -->
    <e-transition-group key="trans" :element="element"></e-transition-group>

    <!-- DOES NOT APPLY TO BACKGROUND IMAGES -->
    <div v-if="!element.isBackground">
      <e-position-group :element="element"></e-position-group>
      <e-size-group :element="element"></e-size-group>
      <e-visibility-group :element="element"></e-visibility-group>
      <!-- <e&#45;pin :element="element"></e&#45;pin> -->
    </div>
  </card>
</template>

<script>
// import Component from "../component_location"
import Card from "./Card.vue";
import EName from "./EName.vue";
import EPositionGroup from "./EPositionGroup";
import EVisibilityGroup from "./EVisibilityGroup";
import ETransitionGroup from "./ETransitionGroup";
import EIsBackground from "./EIsBackground.vue";
import ESelectFile from "./ESelectFile.vue";
import EVideoControls from "./EVideoControls";
import EPin from "./EPin";
import EText from "./EText.vue";
import ESizeGroup from "./ESizeGroup";


export default {
  components: {
    Card,
    EName,
    ETransitionGroup,
    EIsBackground,
    EPositionGroup,
    ESelectFile,
    EVisibilityGroup,
    EVideoControls,
    EPin,
    EText,
    ESizeGroup
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
